import { Capacitor } from '@capacitor/core';
import { CapacitorSQLite, SQLiteConnection } from '@capacitor-community/sqlite';

import { SCHEMA_VERSION } from './schema.js';

const sqlite = new SQLiteConnection(CapacitorSQLite);

let webPreparado = false;

async function prepararWeb() {
    if (webPreparado) return;

    let elemento = document.querySelector('jeep-sqlite');
    if (!elemento) {
        elemento = document.createElement('jeep-sqlite');
        document.body.appendChild(elemento);
    }

    elemento.autosave = true;
    elemento.wasmPath = './assets';

    await customElements.whenDefined('jeep-sqlite');
    await sqlite.initWebStore();

    webPreparado = true;
}

/** @type {import('./portas.js').DriverBanco} */
export const driverCapacitor = {
    async preparar() {
        if (Capacitor.getPlatform() === 'web') await prepararWeb();
    },

    async abrir(nome) {

        const jaExiste = (await sqlite.isConnection(nome, false)).result;
        const conexao = jaExiste
            ? await sqlite.retrieveConnection(nome, false)
            : await sqlite.createConnection(nome, false, 'no-encryption', SCHEMA_VERSION, false);

        await conexao.open();

        return {
            execute: (sql) => conexao.execute(sql),
            query: (sql, params = []) => conexao.query(sql, params),
            run: (sql, params = []) => conexao.run(sql, params),
            close: async () => {
                await conexao.close();
                await sqlite.closeConnection(nome, false);
                if (Capacitor.getPlatform() === 'web') {
                    await sqlite.saveToStore(nome);
                }
            },
        };
    },
};
